import appTokenApi from "../appToken.api";

const useAppTokens = () => {
  const generateAppToken = (kind: string) => appTokenApi.generateAppToken(kind);

  const getAppTokenList = () => appTokenApi.getAppTokenList();

  return {
    generateAppToken,
    getAppTokenList,
  };
};

export default useAppTokens;
